module.exports = __webpack_public_path__ + "img/device-state-indicator-gray.86bfa47d.svg";